module.exports = __webpack_public_path__ + "media/audio28.6daafe76.mp3";